import { champName } from "./Static";

export const ChampionName = ({ cid }) => {
  return champName(cid);
};

export default ChampionName;
